import Button from '@atlaskit/button';
import { Inline } from '@atlaskit/primitives';

interface SaveAndPreviewButtonsProps {
  signup: () => void;
}

export const SignupAndSaveButtons = ({
  signup
}: SaveAndPreviewButtonsProps) => (
  <Inline space="space.050">
    <Button
      tabIndex={-1}
      appearance="primary"
      onClick={signup}
      testId="signup-button"
    >
      {'Get started free'}
    </Button>
  </Inline>
);
